import * as yup from "yup";

export const driverDataSchema = yup.object().shape({
  phone: yup.string().required("phone_required"),
  firstName: yup.string().required("name_required"),
  lastName: yup.string().required("surname_required"),
  email: yup.string().email("enter_valid_email").required("email_required"),
});
